import { useState } from "react";
import { ResizeHandles } from "./components/ResizeHandles";
import { TitleBar } from "./components/TitleBar";
import { useWindowDrag } from "./hooks/useWindowDrag";
import { useWindowResize } from "./hooks/useWindowResize";
import { DraggableWindowProps, PreMaximizeState } from "./types";

export const DraggableWindow = ({ window, onClose, onMinimize, bringToFront }: DraggableWindowProps) => {
    const [isMaximized, setIsMaximized] = useState(false);
    const [preMaximizeState, setPreMaximizeState] = useState<PreMaximizeState | null>(null);

    const { position, setPosition, handleMouseDown } = useWindowDrag(window.position);
    const { size, setSize, handleResizeStart } = useWindowResize(window.size, position, setPosition);

    const toggleMaximize = () => {
        if (!isMaximized) {
            setPreMaximizeState({ position, size });
            setPosition({ x: 0, y: 0 });
            setSize({ width: globalThis.innerWidth, height: globalThis.innerHeight - 48 }); // 48px for taskbar
        } else if (preMaximizeState) {
            setPosition(preMaximizeState.position);
            setSize(preMaximizeState.size);
            setPreMaximizeState(null);
        }
        setIsMaximized(!isMaximized);
    };

    return (
        <div
            className="absolute bg-white rounded-lg shadow-lg overflow-hidden flex flex-col"
            style={{
                left: `${position.x}px`,
                top: `${position.y}px`,
                width: `${size.width}px`,
                height: `${size.height}px`,
                zIndex: window.zIndex,
            }}
            onClick={bringToFront}>
            <TitleBar
                title={window.title}
                isMaximized={isMaximized}
                onMouseDown={handleMouseDown}
                onMinimize={onMinimize}
                onMaximize={toggleMaximize}
                onClose={onClose}
            />

            {/* Window Content */}
            <div className="flex-1 overflow-auto">{window.component}</div>

            {/* Resize Handles */}
            <ResizeHandles onResizeStart={handleResizeStart} />
        </div>
    );
};
